import MessageStatuses from './MessageStatuses';

export default MessageStatuses;